"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DarkGreenText = '#008057';
exports.userSelectStyle = {
    userSelect: 'text',
    '-webkit-user-select': 'text',
    '-moz-user-select': 'text',
    '-ms-user-select': 'text',
};
// These colors are referenced in the DQW tooltip
exports.DataQualityDetailPanelWidth = 300;
exports.DataQualityDetailPanelMaxHeight = 500;
exports.DataQualityStatusChipBackgroundColor = '#D7ECF9';
exports.DataQualityStatusChipSevereBackgroundColor = '#FEF9EF';
exports.DataQualityStatusTitleColor = '#0F445E';
exports.DataQualityStatusSevereTitleColor = '#333333';
//# sourceMappingURL=StyleConstants.js.map